import numeral from 'numeraljs';

import chemicalIcon from 'images/icons/chemical.svg';
import clinAnnIcon from 'images/icons/clinicalAnnotation.svg';
import geneIcon from 'images/icons/gene.svg';
import guidelineIcon from 'images/icons/guideline.svg';
import labelIcon from 'images/icons/label.svg';
import litIcon from 'images/icons/literature.svg';
import pathwayIcon from 'images/icons/pathway.svg';
import variantIcon from 'images/icons/variant.svg';
import varAnnIcon from 'images/icons/variantAnnotation.svg';

import Link from 'components/links/Link';
import Svg from 'components/shared/Svg';

import './StatsGrid.scss';

export default function StatsGrid({data, onSectionClick}) {

  const handleSectionClick = (section) => () => onSectionClick(section);

  return (
    <div className="stat-grid">
      <StatSection title="Guidelines" n={data?.dosing.count} icon={guidelineIcon} onClick={handleSectionClick('ga')}>
        <Link href="#section-ga" newTab={false}>more info</Link>
      </StatSection>
      <StatSection title="Labels" n={data?.labels.count} icon={labelIcon}>
        <Link href="#section-la" newTab={false}>more info</Link>
      </StatSection>
      <StatSection title="Pathways" n={data?.pgkbPathways.count} icon={pathwayIcon}>
        <Link href="#section-pa" newTab={false}>more info</Link>
      </StatSection>
      <StatSection title="Summary Anns" n={data?.clinAnns.count} icon={clinAnnIcon}>
        <Link href="#section-ca" newTab={false}>more info</Link>
      </StatSection>
      <StatSection title="Variant Anns" n={data?.basicVarAnno.count} icon={varAnnIcon}>
        <Link href="#section-va" newTab={false}>more info</Link>
      </StatSection>
      <StatSection title="Annotated Literature" n={data?.litWithAnns.count} icon={litIcon} />
      <StatSection title="Annotated Variants" n={data?.annotatedVariants.count} icon={variantIcon} />
      <StatSection title="Annotated Drugs" n={data?.annotatedChemicals.count} icon={chemicalIcon} />
      <StatSection title="Annotated Genes" n={data?.annotatedGenes.count} icon={geneIcon} />
    </div>
  );
}

function StatSection({title, n, children, icon, onClick}) {
  return (
    <div className="text-sm-right p-3" style={{borderRadius: '0.25rem'}}>
      <div className="ml-2 float-right"><Svg className="annotation-icon" src={icon} /></div>
      <h3 className="mt-0">{title}</h3>
      <p className="mb-0 display-3">{numeral(n).format('0,0')}</p>
      {children}
    </div>
  );
}
